<template>
  <div class="status-indicator" :class="iconStatusClass"></div>
</template>

<script>
const STATUSES_TYPE_ENUM = {
  OK: 1,
  PROBLEM: 2,
  ERROR: 3,
  NOT_CONNECTED: 4
};
export default {
  name: "IntegrationStatusIndicator",
  props: {
    type: {
      type: Number,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconStatusClass() {
      if (this.isDisabled) {
        return "is-disabled";
      }

      const statusClasses = {
        [STATUSES_TYPE_ENUM.OK]: "is-ok",
        [STATUSES_TYPE_ENUM.PROBLEM]: "is-problem",
        [STATUSES_TYPE_ENUM.ERROR]: "is-error",
        [STATUSES_TYPE_ENUM.NOT_CONNECTED]: "is-not-connected"
      };

      return statusClasses[this.type];
    }
  }
};
</script>

<style lang="scss">
.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  flex-shrink: 0;

  &.is-disabled {
    background-color: $gray;
  }

  &.is-ok {
    background-color: $teal;
  }

  &.is-problem {
    background-color: $lime;
  }

  &.is-error {
    background-color: $pink;
  }

  &.is-not-connected {
    background-color: $pink;
  }
}
</style>
